// Translations DE/EN for LetzterSchlüssel
export const translations = {
    de: {
        brand: {
            name: "LetzterSchlüssel",
            tagline: "Dein digitaler Nachlass. Sicher. Für 1 Euro.",
        },
        nav: {
            howItWorks: "So funktioniert's",
            security: "Sicherheit",
            price: "Preis",
            login: "Anmelden",
            getStarted: "Jetzt für 1 €/Monat",
            dashboard: "Dashboard",
            logout: "Abmelden",
            legal: "Rechtliches",
            admin: "Admin",
        },
        landing: {
            eyebrow: "Zero-Knowledge digitaler Nachlass",
            heroTitle: "Wenn du gehst,\nbleibt kein Zugang verloren.",
            heroSub: "1 Euro im Monat tut niemandem weh — aber er nimmt deinen Liebsten im Ernstfall die größte Last ab. Verschlüsselter Safe, Vertrauensperson, Totmannschalter. Alles in drei Klicks.",
            ctaPrimary: "Für 1 €/Monat starten",
            ctaSecondary: "So funktioniert's",
            trustBadges: ["AES-256 im Browser", "DSGVO-konform", "Keine Tracker"],
            howTitle: "Drei Schritte. Kein Fachchinesisch.",
            howSub: "Der Onboarding-Ablauf, für den auch deine Großeltern kein Handbuch brauchen.",
            step1: {
                label: "Schritt 1",
                title: "Dein Safe",
                text: "Schreibe eine Nachricht, hinterlege Passwörter oder Dokumenten-Links. Alles wird bereits in deinem Browser mit AES-256 verschlüsselt — bevor auch nur ein Byte unseren Server sieht.",
            },
            step2: {
                label: "Schritt 2",
                title: "Deine Vertrauensperson",
                text: "Trage Namen und E-Mail der Person ein, die im Ernstfall Zugriff bekommt. Sie erhält eine ruhige, respektvolle Einladung — nichts Beunruhigendes.",
            },
            step3: {
                label: "Schritt 3",
                title: "Dein Lebenszeichen",
                text: "Wähle dein Check-in-Intervall: alle 1, 3 oder 6 Monate ein Klick. Wenn du nicht reagierst, startet unser mehrstufiger Prozess — nie überstürzt.",
            },
            securityTitle: "Was du weißt, wissen wir nicht.",
            securitySub: "Zero-Knowledge ist keine Marketing-Formel. Es bedeutet: dein Master-Passwort verlässt niemals deinen Browser. Selbst wenn unsere Server morgen kompromittiert würden — dein Safe bleibt Rauschen.",
            securityPoints: [
                "AES-256-GCM Client-seitig verschlüsselt",
                "Master-Passwort nur in deinem Kopf",
                "Server sieht nur unlesbare Chiffren",
                "Kein Tracker, keine Werbung",
            ],
            priceTitle: "1 Euro im Monat. Weniger als eine halbe Kugel Eis.",
            priceSub: "Für weniger als den Preis einer halben Kugel Eis im Monat sorgst du dafür, dass niemand nach dir vor verschlossenen Türen steht. Eine minimale Investition, die deinen Liebsten im Ernstfall die größte Last abnimmt. Kündbar jederzeit zum Monatsende — via Digistore24.",
            productType: "Digitales Produkt · Sofortiger Online-Zugang",
            deliveryHint: "Kein Versand · Zugang direkt nach Kauf",
            includesTitle: "Das erhältst du nach dem Kauf",
            priceIncludes: [
                "Digitaler Totmannschalter (Sicherer Nachlass-Tresor)",
                "Automatische Benachrichtigung hinterlegter Vertrauenspersonen",
                "Verschlüsselte Verwahrung persönlicher Daten & Dokumente",
                "Sofortiger Zugriff auf das Web-Dashboard nach Kauf",
            ],
            ctaFinal: "Jetzt für 1 €/Monat starten",
            footerTag: "LetzterSchlüssel — leiser Schutz für deine Liebsten.",
        },
        auth: {
            welcomeBack: "Willkommen zurück",
            createAccount: "Konto erstellen",
            loginSub: "Melde dich an, um zu deinem Safe zu gelangen.",
            registerSub: "In unter 60 Sekunden. 1 € pro Monat — jederzeit kündbar.",
            email: "E-Mail-Adresse",
            password: "Passwort",
            name: "Dein Name",
            login: "Anmelden",
            register: "Konto erstellen",
            or: "oder",
            googleBtn: "Mit Google fortfahren",
            noAccount: "Noch kein Konto?",
            hasAccount: "Schon dabei?",
            registerHere: "Hier registrieren",
            loginHere: "Hier anmelden",
        },
        dashboard: {
            greeting: "Hallo",
            youAreProtected: "Dein Nachlass ist geschützt.",
            nextPing: "Nächstes Lebenszeichen",
            days: "Tage",
            imAlive: "Ich bin da — alles gut",
            imAliveSub: "Setzt deinen Countdown zurück.",
            safeItems: "Einträge im Safe",
            trustedPersons: "Vertrauenspersonen",
            interval: "Intervall",
            months: "Monate",
            state: {
                healthy: "Geschützt",
                pinging: "Warten auf deine Antwort",
                activation_pending: "Aktivierung läuft",
                released: "An Vertrauensperson übergeben",
            },
            activateNow: "Jetzt für 1 €/Monat aktivieren",
            activated: "Abo aktiv — 1 €/Monat",
        },
        safe: {
            title: "Dein Safe",
            sub: "Verschlüsselt in deinem Browser, bevor irgendetwas geladen wird.",
            unlockTitle: "Master-Passwort eingeben",
            unlockSub: "Das Passwort verlässt niemals dein Gerät. Wir können es nicht wiederherstellen.",
            unlockBtn: "Safe öffnen",
            addNew: "Neuer Eintrag",
            kindMessage: "Nachricht",
            kindPassword: "Passwort / Zugang",
            kindDocument: "Dokumenten-Link",
            titleField: "Titel",
            contentField: "Inhalt",
            saveEncrypt: "Verschlüsselt speichern",
            empty: "Noch keine Einträge. Lege den ersten an — dauert 30 Sekunden.",
            deleted: "Eintrag gelöscht",
            savedEnc: "Verschlüsselt und gespeichert",
        },
        trusted: {
            title: "Deine Vertrauenspersonen",
            sub: "Diese Menschen bekommen im Ernstfall Zugriff — nach doppelter Bestätigung.",
            addTitle: "Vertrauensperson hinzufügen",
            name: "Name",
            email: "E-Mail",
            add: "Einladung senden",
            empty: "Noch niemand hinterlegt. Wir empfehlen 1–3 Personen.",
            invited: "Einladung gesendet",
            deleted: "Person entfernt",
        },
        lifesign: {
            title: "Dein Lebenszeichen",
            sub: "Wähle, wie oft die App bei dir nachfragt.",
            options: [
                { m: 1, label: "Monatlich" },
                { m: 3, label: "Alle 3 Monate", recommended: true },
                { m: 6, label: "Halbjährlich" },
            ],
            save: "Intervall speichern",
            saved: "Intervall gespeichert",
        },
        referral: {
            title: "Netzwerk der Sicherheit",
            sub: "Schütze 3 Freunde — teile deinen Sicherheits-Link.",
            share: "Link teilen",
            copied: "Kopiert!",
            invited: "eingeladen",
            activated: "aktiviert",
            bonus: "Bonus-Slots",
            desc: "Wenn eine eingeladene Person die App aktiviert, bekommst du einen zusätzlichen kostenlosen Familien-Slot.",
        },
        activate: {
            title: "Starte dein 1 €/Monat-Abo",
            sub: "1 Euro im Monat — kündbar jederzeit zum Monatsende. Ein Kaffee weniger, dein Nachlass gesichert.",
            checkout: "Jetzt für 1 €/Monat starten",
            success: "Aktiviert! Dein Totmannschalter ist scharf.",
            processing: "Zahlung wird bestätigt…",
            mockNote: "Zahlungsanbieter Digistore24 (Testmodus / MOCK). In der Produktion mit echten Digistore24 API-Zugangsdaten austauschen.",
            perMonth: "/Monat",
            priceBoxTop: "MONATLICH",
            priceBoxBottom: "jederzeit kündbar",
            thankTitle: "Vielen Dank für deinen Kauf!",
            thankBody: "Dein Konto bei Letzter Schlüssel ist jetzt aktiv. Du hast vollen Zugriff auf alle Funktionen.",
            deliveryTitle: "So erhältst du dein Produkt",
            deliveryBody: "LetzterSchlüssel ist eine Web-App unter letzterschluessel.de. Es ist kein Download erforderlich — du erhältst deinen Zugang direkt online. Melde dich einfach mit deiner E-Mail-Adresse und deinem Passwort an, und du kannst alle Funktionen sofort nutzen.",
            step1Title: "Schritt 1",
            step1Body: "Prüfe deine E-Mails für die Kaufbestätigung von Digistore24.",
            step2Title: "Schritt 2",
            step2Body: "Logge dich mit deinen Zugangsdaten ein, um deinen Totmannschalter einzurichten.",
            dashboardBtn: "Direkt zum Dashboard / Login",
            billingNote: "Die Abbuchung erfolgt durch Digistore24.com",
        },
        subscription: {
            title: "Abo-Status",
            active: "Aktiv",
            inactive: "Nicht aktiv",
            sinceDays: "seit {days} Tagen",
            sinceToday: "seit heute",
            manage: "Abo verwalten / Kündigung via Digistore24",
            startNow: "Jetzt für 1 €/Monat starten",
        },
        gift: {
            title: "Sicherheit teilen",
            body: "Empfiehl uns weiter. Für jeden geworbenen Freund schenken wir dir 1 Monat gratis Nutzung!",
            copy: "Link kopieren",
            copied: "Link kopiert!",
            progressNeedOne: "Noch 1 Freund einladen bis zum nächsten Gratismonat!",
            progressPending: "{count} Freund(e) angemeldet — kurz vor dem Meilenstein!",
            progressAchieved: "🎁 Meilenstein {count} erreicht! Noch 1 weiterer Freund bis zum nächsten Gratismonat!",
            milestone: "Meilenstein",
            goalLabel: "Nächster Gratismonat",
        },
        legal: {
            title: "Rechtliches",
            tabs: {
                impressum: "Impressum",
                datenschutz: "Datenschutz",
                agb: "AGB",
            },
            updated: "Zuletzt aktualisiert",
            asOf: "Stand",
        },
        admin: {
            title: "Rechtstexte verwalten",
            sub: "Nur der Master-Zugang kann diese Inhalte ändern.",
            save: "Speichern",
            saved: "Gespeichert",
            noAccess: "Zugriff verweigert — kein Master-Zugang.",
        },
        common: {
            cancel: "Abbrechen",
            delete: "Löschen",
            back: "Zurück",
            confirm: "Bestätigen",
            loading: "Lädt…",
        },
    },
    en: {
        brand: {
            name: "LetzterSchlüssel",
            tagline: "Your digital legacy. Safe. For €1.",
        },
        nav: {
            howItWorks: "How it works",
            security: "Security",
            price: "Price",
            login: "Sign in",
            getStarted: "Start for €1/month",
            dashboard: "Dashboard",
            logout: "Sign out",
            legal: "Legal",
            admin: "Admin",
        },
        landing: {
            eyebrow: "Zero-knowledge digital legacy",
            heroTitle: "When you go,\nno access is lost.",
            heroSub: "€1 a month hurts nobody — but it lifts the biggest burden off your loved ones. Encrypted safe, trusted person, dead-man switch. Three clicks, done.",
            ctaPrimary: "Start for €1/month",
            ctaSecondary: "How it works",
            trustBadges: ["AES-256 in browser", "GDPR compliant", "Zero trackers"],
            howTitle: "Three steps. No jargon.",
            howSub: "The onboarding your grandparents don't need a manual for.",
            step1: {
                label: "Step 1",
                title: "Your Safe",
                text: "Write a message, drop in passwords or document links. Everything is encrypted right in your browser with AES-256 — before a single byte reaches our servers.",
            },
            step2: {
                label: "Step 2",
                title: "Your trusted person",
                text: "Enter the name and email of the person who gets access if the worst happens. They receive a calm, respectful invitation — nothing alarming.",
            },
            step3: {
                label: "Step 3",
                title: "Your life-sign",
                text: "Pick a check-in interval: one click every 1, 3 or 6 months. Miss it and a multi-stage, never-rushed process kicks in.",
            },
            securityTitle: "What you know, we don't.",
            securitySub: "Zero-knowledge isn't a marketing term. Your master password never leaves your browser. Even if our servers were compromised tomorrow — your safe remains noise.",
            securityPoints: [
                "AES-256-GCM encrypted client-side",
                "Master password stays in your head",
                "Server sees only unreadable ciphertext",
                "No trackers, no advertising",
            ],
            priceTitle: "€1 a month. Less than half a scoop of ice cream.",
            priceSub: "For less than half a scoop of ice cream a month, you make sure nobody stands in front of locked doors after you. A minimal investment that lifts the biggest burden off your loved ones. Cancel anytime — via Digistore24.",
            productType: "Digital product · Instant online access",
            deliveryHint: "No shipping · Access right after purchase",
            includesTitle: "What you get after purchase",
            priceIncludes: [
                "Digital dead-man switch (secure legacy vault)",
                "Automatic notification of your trusted persons",
                "Encrypted storage of your personal data & documents",
                "Instant access to the web dashboard after purchase",
            ],
            ctaFinal: "Start for €1/month",
            footerTag: "LetzterSchlüssel — quiet protection for your loved ones.",
        },
        auth: {
            welcomeBack: "Welcome back",
            createAccount: "Create an account",
            loginSub: "Sign in to reach your safe.",
            registerSub: "Under 60 seconds. €1/month — cancel anytime.",
            email: "Email address",
            password: "Password",
            name: "Your name",
            login: "Sign in",
            register: "Create account",
            or: "or",
            googleBtn: "Continue with Google",
            noAccount: "No account yet?",
            hasAccount: "Already with us?",
            registerHere: "Register here",
            loginHere: "Sign in here",
        },
        dashboard: {
            greeting: "Hello",
            youAreProtected: "Your legacy is protected.",
            nextPing: "Next life-sign",
            days: "days",
            imAlive: "I'm here — all good",
            imAliveSub: "Resets your countdown.",
            safeItems: "Safe items",
            trustedPersons: "Trusted persons",
            interval: "Interval",
            months: "months",
            state: {
                healthy: "Protected",
                pinging: "Awaiting your reply",
                activation_pending: "Activation running",
                released: "Handed to trusted person",
            },
            activateNow: "Activate for €1/month",
            activated: "Subscription active — €1/month",
        },
        safe: {
            title: "Your Safe",
            sub: "Encrypted in your browser before anything is uploaded.",
            unlockTitle: "Enter master password",
            unlockSub: "Your password never leaves this device. We cannot recover it.",
            unlockBtn: "Open safe",
            addNew: "New entry",
            kindMessage: "Message",
            kindPassword: "Password / login",
            kindDocument: "Document link",
            titleField: "Title",
            contentField: "Content",
            saveEncrypt: "Encrypt & save",
            empty: "No entries yet. Add your first — takes 30 seconds.",
            deleted: "Entry deleted",
            savedEnc: "Encrypted and stored",
        },
        trusted: {
            title: "Your trusted persons",
            sub: "These people get access if the worst happens — after double confirmation.",
            addTitle: "Add trusted person",
            name: "Name",
            email: "Email",
            add: "Send invitation",
            empty: "Nobody added yet. We recommend 1–3 people.",
            invited: "Invitation sent",
            deleted: "Person removed",
        },
        lifesign: {
            title: "Your life-sign",
            sub: "Choose how often the app should check in with you.",
            options: [
                { m: 1, label: "Monthly" },
                { m: 3, label: "Every 3 months", recommended: true },
                { m: 6, label: "Every 6 months" },
            ],
            save: "Save interval",
            saved: "Interval saved",
        },
        referral: {
            title: "Network of safety",
            sub: "Protect 3 friends — share your safety link.",
            share: "Share link",
            copied: "Copied!",
            invited: "invited",
            activated: "activated",
            bonus: "Bonus slots",
            desc: "When someone you invited activates the app, you unlock an extra free family slot.",
        },
        activate: {
            title: "Start your €1/month subscription",
            sub: "€1 a month — cancel anytime. One coffee less, your legacy secured.",
            checkout: "Start for €1/month",
            success: "Activated! Your dead-man switch is armed.",
            processing: "Confirming payment…",
            mockNote: "Payment provider Digistore24 (test mode / MOCK). Swap real Digistore24 API credentials for production.",
            perMonth: "/month",
            priceBoxTop: "MONTHLY",
            priceBoxBottom: "cancel anytime",
            thankTitle: "Thank you for your purchase!",
            thankBody: "Your Letzter Schlüssel account is now active. You have full access to all features.",
            deliveryTitle: "How you receive your product",
            deliveryBody: "LetzterSchlüssel is a web app at letzterschluessel.de. No download is required — you receive your access directly online. Just log in with your email address and password, and you can use all features immediately.",
            step1Title: "Step 1",
            step1Body: "Check your emails for the Digistore24 purchase confirmation.",
            step2Title: "Step 2",
            step2Body: "Log in with your credentials to set up your dead-man switch.",
            dashboardBtn: "Go to dashboard / login",
            billingNote: "Billing is handled by Digistore24.com",
        },
        subscription: {
            title: "Subscription status",
            active: "Active",
            inactive: "Not active",
            sinceDays: "for {days} days",
            sinceToday: "since today",
            manage: "Manage / cancel via Digistore24",
            startNow: "Start for €1/month",
        },
        gift: {
            title: "Share safety",
            body: "Recommend us. For every friend you refer, we gift you 1 free month!",
            copy: "Copy link",
            copied: "Link copied!",
            progressNeedOne: "Invite 1 more friend to earn your next free month!",
            progressPending: "{count} friend(s) signed up — you're one step from the milestone!",
            progressAchieved: "🎁 Milestone {count} reached! One more friend for the next free month!",
            milestone: "Milestone",
            goalLabel: "Next free month",
        },
        legal: {
            title: "Legal",
            tabs: {
                impressum: "Imprint",
                datenschutz: "Privacy",
                agb: "Terms",
            },
            updated: "Last updated",
            asOf: "As of",
        },
        admin: {
            title: "Manage legal texts",
            sub: "Only the master account can edit these.",
            save: "Save",
            saved: "Saved",
            noAccess: "Access denied — no master privileges.",
        },
        common: {
            cancel: "Cancel",
            delete: "Delete",
            back: "Back",
            confirm: "Confirm",
            loading: "Loading…",
        },
    },
};

export function t(lang, path) {
    const parts = path.split(".");
    let node = translations[lang] || translations.de;
    for (const p of parts) {
        node = node?.[p];
        if (node == null) return path;
    }
    return node;
}
